import React, { useRef } from 'react';

import {
  Divider,
  LegacyBox,
  normalizeMultiSelectValue,
  ActionBar,
  View,
  styled,
  css,
  CheckboxGroupFormLabel,
  Actions,
  Action,
} from '@gogame/components';
import { withForm, FormField, getIn } from '@gogame/form';

import {
  loadAnnotationTypes,
  loadAnnotationSubTypes,
} from 'scenes/Trackers/Tracker/sources/trackerChart';

import {
  ANNOTATIONS_SETTINGS_MINE_ONLY,
  ANNOTATIONS_SETTINGS_SUB_TYPES,
  ANNOTATIONS_SETTINGS_TYPE,
} from '../constants';

const VerticalCheckboxGroup = styled(FormField.CheckboxGroup)`
  div[name='${(props) => props.name}'] {
    flex-direction: column;
  }
  ${(props) =>
    props.hidden &&
    css`
      display: none;
    `}
`;

const TYPE_GAME = 0;

export const AnnotationsForm = withForm({
  enableReinitialize: true,
})(({ submitForm, hierarchyState, onCancel, values }) => {
  const valuesRef = useRef(values);
  const subTypesVisible = !!getIn(
    hierarchyState,
    `${ANNOTATIONS_SETTINGS_SUB_TYPES}.data.length`
  );
  const typesLoading = getIn(
    hierarchyState,
    `${ANNOTATIONS_SETTINGS_TYPE}.loading`
  );

  valuesRef.current = values;
  // TODO: fix normalize, it doesn't update on changing params
  const normalizeSubTypes = (value, data) => {
    const normalized = normalizeMultiSelectValue(value, data) || [];
    if (data && data.length && (!normalized.length || normalized !== value)) {
      if (valuesRef.current[ANNOTATIONS_SETTINGS_TYPE] === TYPE_GAME) {
        return [data[0].id];
      }
      return data.map((subType) => subType.id);
    }
    return normalized;
  };

  return (
    <LegacyBox
      grow={1}
      style={{ maxHeight: '100%' }}
      data-cy={'annotationsFilter'}
    >
      <Divider orientation={'vertical'} flexItem />
      <LegacyBox vertical={true} grow={1}>
        <ActionBar
          title={'Annotations Filter'}
          primaryActions={
            <Actions>
              <Action button onClick={onCancel} label={'Cancel'} />
              <Action
                button
                onClick={submitForm}
                variant={'outlined'}
                label={'Apply'}
              />
            </Actions>
          }
        />
        <Divider />
        <LegacyBox vertical={true} grow={1} style={{ overflowY: 'auto' }}>
          <View loading={typesLoading}>
            <LegacyBox align={'flex-start'}>
              <LegacyBox
                width={'28%'}
                vertical={true}
                style={{ position: 'sticky', top: '0', paddingLeft: '8px' }}
              >
                <FormField.RadioGroup
                  title={'Type'}
                  padding={'16px 8px'}
                  name={ANNOTATIONS_SETTINGS_TYPE}
                  source={loadAnnotationTypes}
                  radioVertical={true}
                />
              </LegacyBox>
              <LegacyBox
                width={'45%'}
                vertical={true}
                style={subTypesVisible ? null : { display: 'none' }}
              >
                <VerticalCheckboxGroup
                  title={'Sub-types'}
                  name={ANNOTATIONS_SETTINGS_SUB_TYPES}
                  depends={[ANNOTATIONS_SETTINGS_TYPE]}
                  source={loadAnnotationSubTypes}
                  normalizeValue={normalizeSubTypes}
                  vertical={true}
                />
              </LegacyBox>
              <LegacyBox
                vertical={true}
                style={{ padding: '16px 8px', position: 'sticky', top: '0' }}
              >
                <CheckboxGroupFormLabel>Show</CheckboxGroupFormLabel>
                <FormField.Checkbox
                  name={ANNOTATIONS_SETTINGS_MINE_ONLY}
                  label={'Only mine'}
                  padding={'0'}
                />
              </LegacyBox>
            </LegacyBox>
          </View>
        </LegacyBox>
      </LegacyBox>
    </LegacyBox>
  );
});

export default AnnotationsForm;
